import React, {useEffect} from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import {ReactComponent as SvgDotPatternIcon} from "../../images/dot-pattern.svg"

import { useForm } from "react-hook-form";

import { useSnackbar } from "react-simple-snackbar";

import 'components/forms/SimpleContactUsLogin.css'

const Container = tw.div`relative`;
const Content = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;

const FormContainer = styled.div`
  ${tw`p-10 sm:p-12 md:p-16 bg-primary-500 text-gray-100 rounded-lg relative`}
  form {
    ${tw`mt-4`}
  }
  h2 {
    ${tw`text-3xl sm:text-4xl font-bold`}
  }
  input,textarea {
    ${tw`w-full bg-transparent text-gray-100 text-base font-medium tracking-wide border-b-2 py-2 text-gray-100 hocus:border-pink-400 focus:outline-none transition duration-200`};

    ::placeholder {
      ${tw`text-gray-500`}
    }
  }
`;

const TwoColumn = tw.div`flex flex-col sm:flex-row justify-between`;
const Column = tw.div`sm:w-5/12 flex flex-col`;
const InputContainer = tw.div`relative py-5 mt-6`;
const Label = tw.label`absolute top-0 left-0 tracking-wide font-semibold text-sm`;
const Input = tw.input``;
const TextArea = tw.textarea`h-24 sm:h-full resize-none`;
const SubmitButton = tw.button`w-full sm:w-32 mt-6 py-3 bg-gray-100 text-primary-500 rounded-full font-bold tracking-wide shadow-lg uppercase text-sm transition duration-300 transform focus:outline-none focus:shadow-outline hover:bg-gray-300 hover:text-primary-700 hocus:-translate-y-px hocus:shadow-xl`;

const SvgDotPattern1 = tw(SvgDotPatternIcon)`absolute bottom-0 right-0 transform translate-y-1/2 translate-x-1/2 -z-10 opacity-50 text-primary-500 fill-current w-24`

export default ({toggleModalLogin, loggato, setLoggato, update}) => {

  const { register, handleSubmit, watch, errors, setValue } = useForm();
  const [openSnackbar, closeSnackbar] = useSnackbar();

  useEffect(() => {

    if(localStorage.getItem("nome_1000") !== null && localStorage.getItem("citta_1000") !== null){

      setValue("nome", localStorage.getItem("nome_1000"));
      setValue("citta", localStorage.getItem("citta_1000"))
      
    }
  
  }, [])

  var today = new Date();
  var dd = String(today.getDate()).padStart(2, '0');
  var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
  var yyyy = today.getFullYear();

  today = dd + '/' + mm + '/' + yyyy;

  
  const onSubmit = data => {
    console.log(data);

    if(data.nome!=='' && data.citta!==''){

      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: JSON.stringify(data)
      };

      fetch('https://recode.digital/corona-anti-virus/index.php/api/crea_preghiera/', requestOptions)
        .then(response => response.text())
        .then(risp => {
          if(risp.trim() === "ok"){

            localStorage.setItem('nome_1000', data.nome);
            localStorage.setItem('citta_1000', data.citta);
            localStorage.setItem('data_1000', today);
            openSnackbar('Grazie!');

          }

        });

        toggleModalLogin();

        const formData = new FormData();

        formData.append('data', today); 

        const requestOptions2 = {
          method: 'POST',
          body: formData
          //Essendo creato con FormData non devo specificare headers
        };

        fetch('https://recode.digital/corona-anti-virus/index.php/api/conta_preghiere/', requestOptions2)
                .then(response => response.text())
                .then(risp => {

                  update(parseInt(risp))
                });  

    }else{
      openSnackbar('Compilare tutti i campi richiesti');
    }
  }

  return (
    <Container id="form_iscrizione">
      <Content>
        <FormContainer>
          <div tw="mx-auto max-w-4xl" >
            <div style={{textAlign:"right"}} onClick={toggleModalLogin}>
              <p><b>X Close</b></p>
            </div>
            <h2>Subscribe now 🙏🏻</h2>
            <form onSubmit={handleSubmit(onSubmit)}>
              <input type="hidden" ref={register} value={today} name="data"/>
              <TwoColumn>
                <Column>
                  <InputContainer>
                    <Label htmlFor="email-input">Your Birth Name</Label>
                    <Input ref={register} id="nome" type="text" name="nome" placeholder="" />
                  </InputContainer>
                </Column>
                <Column>
                <InputContainer>
                    <Label htmlFor="password">City</Label>
                    <Input ref={register} id="citta" type="text" name="citta" placeholder="" />
                  </InputContainer>
                </Column>
              </TwoColumn>

              <SubmitButton style={{width:"100%"}}type="submit" value="Submit">Confirm that you've prayed the Holy Cloack today 🙏🏻</SubmitButton>
            </form>
          </div>
          <SvgDotPattern1 />
        </FormContainer>
      </Content>
    </Container>
  );
};
